import * as React from "react";
import { forwardRef } from "react";
const SvgMonitor = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.6663 12.25H9.33334M6.99982 9.91667V12.25M2.33278 1.75H11.6669C12.3112 1.75 12.8336 2.27233 12.8336 2.91667V8.75C12.8336 9.39433 12.3112 9.91667 11.6669 9.91667H2.33278C1.68839 9.91667 1.16602 9.39433 1.16602 8.75V2.91667C1.16602 2.27233 1.68839 1.75 2.33278 1.75Z", stroke: "#61687B", strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgMonitor);
export { ForwardRef as ReactComponent };
